<template>
  <el-drawer
    title="DETALLE DE SATISFACCION"
    :visible.sync="drawer"
    size="80%"
    :before-close="handleBeforeClose"
  >
    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
      <el-row style="padding: 20px">
        <table style="font-size: 25px" id="table-card">
          <tr style="font-size: 25px">
            <td>Soporte:</td>
            <td>
              <strong> {{ tecnico }}</strong>
            </td>
          </tr>
        </table>
      </el-row>
    </el-col>

    <el-col :span="3" :xs="3" :sm="24" :md="24" :lg="8">
      <el-row style="padding: 20px">
        <table style="font-size: 25px" id="table-card">
          <tr>
            <td width="10%">Mes:</td>
            <td width="60%" style="align-items: flex-start">
              <strong> {{ month }}</strong>
            </td>
          </tr>
        </table>
      </el-row>
    </el-col>
    <el-col :span="6" :xs="6" :sm="24" :md="24" :lg="8">
      <el-row style="padding: 20px">
        <table style="font-size: 25px" id="table-card">
          <tr style="font-size: 20px">
            <td width="30%">Total Estrellas:</td>
            <td>
              <strong> {{ TotalEstrellas }}</strong>
            </td>
          </tr>

          <tr style="font-size: 20px">
            <td width="30%">Total Registros:</td>
            <td>
              <strong> {{ Total }}</strong>
            </td>
          </tr>
          <tr style="font-size: 20px">
            <td width="30%">Total sin Calificar:</td>
            <td>
              <el-tag type="danger" style="font-size: 25px">{{
                TotalSinCalificar
              }}</el-tag>
              <!-- <strong> {{ TotalSinCalificar }}</strong> -->
            </td>
          </tr>
          <tr style="font-size: 20px">
            <td width="30%">Efectividad:</td>
            <td>
              <el-tag :type="getTagType" style="font-size: 25px">{{
                percent
              }}</el-tag>
            </td>
          </tr>
        </table>
      </el-row>
    </el-col>
    <div>
      <div class="text-right">
        <p>
          :
          <span class="label label-danger" style="font-size: 22px">
            <template> </template>
          </span>
        </p>
      </div>

      <el-row style="padding: 20px">
        <RabbeyTable3
          ref="table"
          v-loading="loadingDetails"
          :columns="columnsDetails"
          :summary-method="getSummariesKPI"
          :data="RegisteredKPISupport"
          :height="560"
        />
      </el-row>
    </div>
  </el-drawer>
</template>

<script>
import {
  formatMontoKPI,
  FormatPercentSalesKpi,
  GetMonthInLetterBeginingOnZero
} from "@/utils";
import { getSummariesKPI } from "@/helpers/TableRabbeyTools";
import { DetailSatisfaccionKpi } from "@/helpers/SatisfaccionColumns";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";

export default {
  name: "DetailSatisfaccionKpi",
  components: {
    RabbeyTable3
  },
  data() {
    return {
      metaMount: 0,
      RegisteredKPISupport: [],
      drawer: false,
      month: "",
      SellerName: "",
      tecnico: "",
      tecnicoID: "",
      ClientCode: "",
      serviceTypeId: null,
      productId: null,
      valoracionTypeId: null,
      columnsDetails: [...DetailSatisfaccionKpi],
      loadingDetails: false,
      slaTracker: {
        Failed: 0,
        Compliment: 1
      }
    };
  },
  computed: {
    Total: function () {
      return this.RegisteredKPISupport.length;
    },
    TotalSinCalificar: function () {
      return this.RegisteredKPISupport.filter((r) => r.valoracion == 0).length;
    },

    TotalEstrellas: function () {
      if (this.RegisteredKPISupport.length <= 0) {
        return 0;
      }

      return this.RegisteredKPISupport.filter((item) => item.valoracion > 0)
        .map((item) => item.valoracion)
        .reduce((a, c) => a + c);
    },
    promedio: function () {
      return this.TotalEstrellas / this.Total;
    },
    percent: function () {
      return formatMontoKPI((this.promedio / 5) * 100) + "%";
    },
    getTagType() {
      if (this.percent.replace("%", "") <= 70) {
        return "danger";
      } else if (this.percent.replace("%", "") >= 90) {
        return "success";
      } else if (
        this.percent.replace("%", "") >= 71 &&
        this.percent.replace("%", "") <= 89
      ) {
        return "warning";
      }
      return "info";
    }
  },

  methods: {
    FormatPercentSalesKpi,
    formatMontoKPI,
    getSummariesKPI,
    show(row, month, year) {
      //console.log("hola show row:", row);
      const monthT = GetMonthInLetterBeginingOnZero(month - 1);
      this.month = this.$t(`months.${monthT}`);
      this.tecnico = row.technical;
      this.tecnicoID = row.technicalId;
      this.ClientCode = row.clientCode;
      this.serviceTypeId = row.currentServiceTypeId;
      this.productId = row.currentProductId;
      this.valoracionTypeId = row.currentvaloracionId;

      this.getDetailsinfoSLA(month, year);
      this.drawer = true;
    },

    getDetailsinfoSLA(month = Number, year = Number) {
      this.loadingDetails = true;
      const param = {
        mes: month,
        ClientCode: this.ClientCode,
        tecnicoID: this.tecnicoID,
        serviceTypeID: this.serviceTypeId,
        product: this.productId,
        valoracionTypeID: this.valoracionTypeId,
        year: year,
        companyID: this.currentCompany
      };
      const api = `/api/KpiTechnicalSupport/GetDetailsKpiSatisfaccionbyTechnical`;
      this.$http
        .get(api, { params: param })
        .then(({ data }) => {
          this.RegisteredKPISupport = data;
          this.loadingDetails = false;
        })
        .catch((error) => {
          this.$message.error("Error al consultar el detalle");
          console.error(error);
        })
        .finally(() => {
          this.loadingDetails = false;
        });
    },
    handleBeforeClose(done) {
      done();
    }
  }
};
</script>
